<template>
    <div class="eyebrow">
        <slot v-if="icon" name="icon"> <i :class="icon" /> · </slot>
        <slot></slot>
    </div>
</template>

<script lang="ts" setup>
defineProps<{
    icon?: string;
}>();
</script>

<style lang="scss" scoped>
.eyebrow {
    --p-icon-size: 0.667rem;

    color: var(--stekz-primary-color);
    font-size: 0.667rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin-bottom: 0.5rem;
}
</style>
